// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__uIv0k","col":"styles_col__IFWZy"};